import { FOLLOWUP_SURVEYS_CSV_REPORT_RECEIVE } from 'actions/followup';

const defaultState = {};

export default function followUpSurveysCSVReport(state = defaultState, action) {
  switch (action.type) {
    case FOLLOWUP_SURVEYS_CSV_REPORT_RECEIVE:
      return action.payload;
    default:
      return state;
  }
}
